/** 后台主题色（5 套可切换，含侧栏/顶栏背景） */

export const THEME_STORAGE_KEY = 'zhihuiruanqi-admin-theme'

export const THEMES = [
  {
    id: 'blue',
    name: '科技蓝',
    primary: '#1677ff',
    primaryLight: '#e8f3ff',
    primaryDark: '#0958d9',
    primaryHover: '#4096ff',
    sidebarFrom: '#0b1a33',
    sidebarTo: '#0f2844',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(22, 119, 255, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#e8f3ff',
    headerTo: '#ffffff',
    layoutBg: '#eef3fb'
  },
  {
    id: 'green',
    name: '燃气绿',
    primary: '#00b42a',
    primaryLight: '#e8ffea',
    primaryDark: '#009a29',
    primaryHover: '#23c343',
    sidebarFrom: '#052e14',
    sidebarTo: '#0a4520',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(0, 180, 42, 0.35)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#e8ffea',
    headerTo: '#ffffff',
    layoutBg: '#eefbf0'
  },
  {
    id: 'purple',
    name: '智慧紫',
    primary: '#722ed1',
    primaryLight: '#f9f0ff',
    primaryDark: '#531dab',
    primaryHover: '#9254de',
    sidebarFrom: '#160826',
    sidebarTo: '#2a1050',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(114, 46, 209, 0.38)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#f3e8ff',
    headerTo: '#ffffff',
    layoutBg: '#f5f0fc'
  },
  {
    id: 'orange',
    name: '活力橙',
    primary: '#ff7d00',
    primaryLight: '#fff7e8',
    primaryDark: '#d25f00',
    primaryHover: '#ff9a2e',
    sidebarFrom: '#2a1400',
    sidebarTo: '#4a2800',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(255, 125, 0, 0.35)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#fff7e8',
    headerTo: '#ffffff',
    layoutBg: '#fff8f0'
  },
  {
    id: 'cyan',
    name: '海洋青',
    primary: '#13c2c2',
    primaryLight: '#e6fffb',
    primaryDark: '#08979c',
    primaryHover: '#36cfc9',
    sidebarFrom: '#032828',
    sidebarTo: '#064545',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(19, 194, 194, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#e6fffb',
    headerTo: '#ffffff',
    layoutBg: '#ecfafa'
  }
]

export const DEFAULT_THEME_ID = 'blue'

export function getThemeById(id) {
  return THEMES.find(t => t.id === id) || THEMES[0]
}
